import { PublishTradingOfferModalContextType } from '../types/PublishTradingOfferModalContextType';

export const publishTradingOfferModalInitValue: PublishTradingOfferModalContextType =
  {
    data: {
      modalActionType: '',
      tradingOffer: null,
      publishedOffer: null,
      validityDays: 0,
      isTermsAndConditionsAccepted: false,
      isHideSellerName: false,
      isLoading: true,
    },
    actions: {
      handleCloseModal: () => {},
      handleChangeTermsAndConditionsAcceptance: () => {},
      handleChangeHideSellerName: () => {},
      handlePublishTradingOffer: async () => {},
    },
  };
